// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2cYJj","select":"Header_select__3O4IZ","clinic":"Header_clinic__11bMc"};